import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { PriorAuthSyncResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { triggerPriorAuthSync } from '../api/priorAuthApi';
import { priorAuthKeys } from './keys';

export interface PriorAuthSyncVariables {
  patientUserId: string;
}

/**
 * Forces an immediate PA poll + discovery pass scoped to one patient.
 *
 * The backend polls only the logged-in clinician's pending cases for the
 * given patient, discovers any in-progress cases on DoseSpot not yet
 * tracked locally, then runs the global processor.
 */
export function usePriorAuthSyncMutation() {
  const queryClient = useQueryClient();

  return useMutation<PriorAuthSyncResponseT, Error, PriorAuthSyncVariables>({
    mutationKey: ['priorAuth', 'sync'],
    mutationFn: (variables) => triggerPriorAuthSync(variables.patientUserId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: priorAuthKeys.all,
      });
    },
  });
}
